export const USER_LOGIN_SUCCESS = "userLoginSuccess";
export const USER_LOGIN_FAIL = "userLoginFail";